import { useAccount, useIsAuthenticated } from '@azure/msal-react';

const UserRoles = { Administrator: 'Administrator' };

function useUserData() {
  const azureData = useAccount();
  const isAuthenticated = useIsAuthenticated();

  const loggedIn = isAuthenticated;
  const name = azureData?.name;
  const isAdministrator = azureData?.idTokenClaims?.roles?.includes(UserRoles.Administrator);

  return { loggedIn, name, isAdministrator };
}

export default useUserData;
